// USP data interface

// USP types
export var USPType = {
  GUARANTEE_FEATURES: "GUARANTEE_FEATURES",
  WHY_TO_BUY: "WHY_TO_BUY",
  BUYING_PROCESS: "BUYING_PROCESS"
};

// TypeScript type for USP types